export default __webpack_public_path__ + "static/media/fbx.ce3c067a.png";